$(document).ready(function () {

    $('#requestDownloadAppButton').on('click', function () {
        $('#download-digidos-app').trigger('click');
    });

    if ($('#authReminderModal').length === 0) {
        $('#appReminderModal').modal('show');

        $('#activateAppReminderDownload').on('click', function () {
            $('#appReminderModal').modal('hide');

            setTimeout(function () {
                $('#download-digidos-app').trigger('click');
            }, 600);
        });
    }
});
